import Moment from 'moment'
import { TaskCategories } from '../../classes/Api/Task'

export let TaskPercentageDisplay = {
    methods: {
        getDealTasksStatusBadgeClass(deal, instance, teamId = null) {
            let total = this.getDealTasks(instance, teamId);
            let completed = this.getDealTasksCompleted(instance, teamId).length;
            let daysRemaining = null;

            if (deal.handover_booking) {
                daysRemaining = Moment(deal.handover_booking.from).diff(Moment(), 'days')
            }
            
            if (parseInt(completed) === parseInt(total.length)) {
                return 'badge badge-success'
            }

            if (daysRemaining < 2) {
                return 'badge badge-danger'
            }

            if (daysRemaining < 3) {
                return 'badge badge-warning'
            }

            return 'badge badge-secondary'
        },
        getDealTasks(instance, teamId = null) {
            let invalidTypes = [
                TaskCategories.SNAGGING, 
                TaskCategories.WARRANTY, 
                TaskCategories.SERVICING
            ];

            return instance.jobs.filter(
                item => (
                    invalidTypes.indexOf(item.category) === -1 &&
                    (!teamId || item.team_id === teamId)
                )
            )
        },
        getDealTasksCompleted(instance, teamId = null) {
            return this.getDealTasks(instance, teamId).filter(item => (item.completed_at !== null));
        },
        getDealTasksPercentage(instance, teamId = null) {
            if (this.getDealTasks(instance, teamId).length === 0) {
                return 100;
            }

            return this.getDealTasksCompleted(instance, teamId).length / (this.getDealTasks(instance, teamId).length / 100); 
        },
    }
}